module.exports = __webpack_public_path__ + "media/images/reseller-df2be4ef.jpg";